import { AnalyticsEventBuilder, AnalyticsEvent, AnalyticsEventAction } from '../AnalyticsEventBuilder';
import { Game }        from '../../../models/Game';
import { environment } from '../../../config/environment';

export class GamesAnalyticsGa {
    gameStart(game: Game): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Funnel_Content_Start');
        event.setEventGaAction(game.slug);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(false);
        return event.build();
    }

    gameEnd(game: Game, duration: number): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Funnel_End_Screen');
        event.setEventGaAction(game.slug);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(false);
        return event.build();
    }

    playAgainClick(game: Game): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Funnel_End_Button_PlayAgain');
        event.setEventGaAction(AnalyticsEventAction.CLICK);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(false);
        return event.build();
    }

    playAgainImpressions(game: Game): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Funnel_End_Button_PlayAgain');
        event.setEventGaAction(AnalyticsEventAction.IMPRESSION);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(true);
        return event.build();
    }

    gameEndShareClick(game: Game): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Share_Button');
        event.setEventGaAction(AnalyticsEventAction.CLICK);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(false);
        return event.build();
    }

    gameEndEngagementPromoClick(game: Game): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Funnel_End_Button_Promo_Up');
        event.setEventGaAction(AnalyticsEventAction.CLICK);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(false);
        return event.build();
    }

    gameEndCrossPromotionClick(game: Game): AnalyticsEvent {
        const event = this.newEventBuilder();
        event.setEventGaCategory('Funnel_End_Button_Promo_Lower');
        event.setEventGaAction(AnalyticsEventAction.CLICK);
        event.setEventGaLabel(environment.ARENA_DOMAIN + ' | ' + game.slug);
        event.setNonInteraction(false);
        return event.build();
    }

    private newEventBuilder(): AnalyticsEventBuilder {
        return (new AnalyticsEventBuilder());
    }
}
